import { Navigate, useParams } from 'react-router-dom';

/**
 * Links in emails the API has sent over the years that never had a page.
 * They redirect to the page that now does the job, so emails already in
 * people's inboxes keep working. The API now sends the new links.
 *
 * Interview links are handled with the ATS routes.
 */
export const MY_TIME_AWAY_PATH = '/time-off?tab=mine';

/** Redirects to `to`, with `:id` replaced by the matched id. */
function RedirectWithId({ to }: { to: (id: string) => string }) {
  const { id } = useParams();
  return <Navigate replace to={id ? to(encodeURIComponent(id)) : '/time-off'} />;
}

const toRequest = (id: string) => `/time-off/${id}`;

export const LEGACY_REDIRECTS: Array<{ path: string; element: JSX.Element }> = [
  // Submission, decision and balance emails.
  { path: '/timeaway/my-requests', element: <Navigate replace to={MY_TIME_AWAY_PATH} /> },
  { path: '/timeaway/my-allowance', element: <Navigate replace to={MY_TIME_AWAY_PATH} /> },
  { path: '/timeaway/my-requests/:id/edit', element: <RedirectWithId to={toRequest} /> },
  // Approval-workflow emails (manager, HR and document requests). These only
  // show the request; a decision is never taken from these links.
  { path: '/approvals/review/:id', element: <RedirectWithId to={toRequest} /> },
  { path: '/hr/approvals/:id', element: <RedirectWithId to={toRequest} /> },
  { path: '/timeaway/documents/:id', element: <RedirectWithId to={toRequest} /> },
  // User invitation emails: the person already has an account; sign in.
  { path: '/invite/:id', element: <Navigate replace to="/" /> },
];
